<template>
    <authenticated-layout>
        <v-card class="pa-6">
            <v-card-title
                class="d-flex justify-space-between align-center pa-0 py-3"
            >
                <v-btn
                    variant="flat"
                    size="small"
                    color="primary"
                    @click="openModal()"
                >
                    {{ $t("water-container.addNewOne") }}
                </v-btn>
            </v-card-title>

            <div class="overflow-x-auto">
                <table>
                    <tr>
                        <th>#ID</th>
                        <th>{{ $t("water-container.Brand") }}</th>
                        <th>{{ $t("water-container.Model") }}</th>
                        <th>{{ $t("water-container.Material") }}</th>
                        <th>{{ $t("water-container.Volume") }}</th>
                        <th>{{ $t("water-container.Warranty") }}</th>
                        <th>{{ $t("water-container.Buying price") }}</th>
                        <th>{{ $t("water-container.Selling price") }}</th>
                        <th>{{ $t("water-container.Number of coils") }}</th>
                        <th>{{ $t("water-container.Total coil length") }}</th>
                        <th>{{ $t("water-container.Image") }}</th>
                        <th>{{ $t("water-container.Visible") }}</th>
                        <th>&nbsp;</th>
                    </tr>

                    <tr v-for="row in waterContainers" :key="`wc-${row.id}`">
                        <td>{{ row.id }}</td>
                        <td>{{ row.brand }}</td>
                        <td>{{ row.model }}</td>
                        <td>{{ row.material }}</td>
                        <td>{{ row.volume }}</td>
                        <td>{{ row.warranty }}</td>
                        <td>{{ row.buying_price }}</td>
                        <td>{{ row.selling_price }}</td>
                        <td>{{ row.number_of_coils }}</td>
                        <td>{{ row.total_coil_length }}</td>
                        <td>
                            <img :src="row.image_url" width="50" />
                        </td>
                        <td>
                            <input
                                type="checkbox"
                                @change="updateVisibility(row)"
                                :checked="row.visible"
                                class="bg-gray-200"
                            />
                        </td>
                        <td class="text-right">
                            <div class="d-flex flex-col">
                                <v-btn
                                    variant="flat"
                                    size="x-small"
                                    color="primary"
                                    @click="edit(row)"
                                >
                                    {{ $t("water-container.edit") }}
                                </v-btn>

                                <v-btn
                                    variant="flat"
                                    size="x-small"
                                    class="mt-1"
                                    color="error"
                                    @click="deleteRow(row)"
                                >
                                    {{ $t("water-container.delete") }}
                                </v-btn>
                            </div>
                        </td>
                    </tr>
                </table>
            </div>

            <v-dialog v-model="isModalOpen" max-width="700" persistent scrollable>
                <v-form
                    ref="form"
                    @submit.prevent="onSubmit">
                    <v-card>
                        <v-card-title class="text-subtitle-1">
                            {{ editMode ? $t("water-container.edit") : $t("water-container.addNewOne") }}
                        </v-card-title>

                        <v-divider />

                        <v-card-text style="max-height: 53vh">
                            <v-text-field
                                v-model="form.brand"
                                :label="$t('water-container.Brand')"
                                variant="outlined"
                                density="compact"
                                type="input"
                                :rules="[$validationRules.required]"
                                :error-messages="
                                    errors.brand ? [errors.brand[0]] : []
                                "
                            />

                            <v-text-field
                                v-model="form.model"
                                :label="$t('water-container.Model')"
                                variant="outlined"
                                density="compact"
                                type="input"
                                :rules="[$validationRules.required]"
                                :error-messages="
                                    errors.model ? [errors.model[0]] : []
                                "
                            />

                            <v-text-field
                                v-model="form.material"
                                :label="$t('water-container.Material')"
                                variant="outlined"
                                density="compact"
                                type="input"
                                :rules="[$validationRules.required]"
                                :error-messages="
                                    errors.material ? [errors.model[0]] : []
                                "
                            />

                            <v-text-field
                                v-model="form.volume"
                                :label="$t('water-container.Volume')"
                                variant="outlined"
                                density="compact"
                                type="input"
                                :rules="[$validationRules.required, $validationRules.number]"
                                :error-messages="
                                    errors.volume ? [errors.volume[0]] : []
                                "
                            />

                            <v-text-field
                                v-model="form.warranty"
                                :label="$t('water-container.Warranty')"
                                variant="outlined"
                                density="compact"
                                type="input"
                                :rules="[$validationRules.required, $validationRules.number]"
                                :error-messages="
                                    errors.warranty ? [errors.warranty[0]] : []
                                "
                            />

                            <v-text-field
                                v-model="form.buying_price"
                                :label="$t('water-container.Buying price')"
                                variant="outlined"
                                density="compact"
                                type="input"
                                :rules="[$validationRules.required, $validationRules.number]"
                                :error-messages="errors.buying_price ? [errors.buying_price[0]] : []"
                            />

                            <v-text-field
                                v-model="form.selling_price"
                                :label="$t('water-container.Selling price')"
                                variant="outlined"
                                density="compact"
                                type="input"
                                :rules="[$validationRules.required, $validationRules.number]"
                                :error-messages="errors.selling_price ? [errors.selling_price[0]] : []"
                            />

                            <v-text-field
                                v-model="form.number_of_coils"
                                :label="$t('water-container.Number of coils')"
                                variant="outlined"
                                density="compact"
                                type="input"
                                :rules="[$validationRules.required, $validationRules.number]"
                                :error-messages="errors.number_of_coils ? [errors.number_of_coils[0]] : []"
                            />

                            <v-text-field
                                v-model="form.total_coil_length"
                                :label="$t('water-container.Total coil length')"
                                variant="outlined"
                                density="compact"
                                type="input"
                                :rules="[$validationRules.required, $validationRules.number]"
                                :error-messages="errors.total_coil_length ? [errors.total_coil_length[0]] : []"
                            />

                            <div class="mb-4">
                                <label
                                    for="product_image"
                                    class="block text-gray-700 text-sm font-bold mb-2"
                                >
                                    {{ $t("heatpump.photo") }}:
                                </label>

                                <div v-if="editMode">
                                    <div
                                        v-show="!uploadNewProductImage"
                                        class="flex justify-start items-center"
                                    >
                                        <img :src="form.image_url" width="70" />
                                        <div>
                                            <button
                                                @click="
                                                    uploadNewProductImage = true
                                                "
                                                type="button"
                                                class="bg-blue-500 hover:bg-blue-700 text-white font-bold ml-3 py-1 px-2 text-sm rounded"
                                            >
                                                {{ $t("Upload new") }}
                                            </button>
                                        </div>
                                    </div>

                                    <v-file-input
                                        v-show="uploadNewProductImage"
                                        :label="$t('water-container.Click in this field to select a picture')"
                                        id="picture"
                                        ref="picture"
                                        accept="image/*"
                                        class="cursor-pointer"
                                        :rules="uploadNewProductImage ? [$validationRules.required, $validationRules.mimes] : []"
                                    />
                                </div>

                                <div v-else>
                                    <v-file-input
                                        :label="$t('water-container.Click in this field to select a picture')"
                                        id="picture"
                                        ref="picture"
                                        accept="image/*"
                                        class="cursor-pointer"
                                        :rules="[$validationRules.required, $validationRules.mimes]"
                                    />
                                </div>

                                <div
                                    v-if="errors.picture"
                                    class="text-red-500"
                                >
                                    {{ errors.picture[0] }}
                                </div>
                            </div>
                        </v-card-text>

                        <v-divider />

                        <v-card-actions>
                            <v-spacer />

                            <v-btn
                                variant="flat"
                                size="small"
                                @click="closeModal()"
                            >
                                {{ $t("water-container.cancel") }}
                            </v-btn>

                            <v-btn
                                v-show="!editMode"
                                color="secondary"
                                variant="flat"
                                size="small"
                                type="submit"
                            >
                                {{ $t("water-container.save") }}
                            </v-btn>

                            <v-btn
                                v-show="editMode"
                                color="secondary"
                                variant="flat"
                                size="small"
                                type="submit"
                            >
                                {{ $t("water-container.update") }}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>

        </v-card>
    </authenticated-layout>
</template>

<script>
import AuthenticatedLayout from "@/Layouts/Authenticated";

export default {
    components: {
        AuthenticatedLayout,
    },
    props: {
        waterContainers: {
            type: Array,
            required: true,
        },
        errors: {
            type: Object,
            required: false,
        },
    },
    data() {
        return {
            editMode: false,
            isModalOpen: false,
            form: {
                id: null,
                brand: null,
                model: null,
                material: null,
                volume: null,
                warranty: null,
                buying_price: null,
                selling_price: null,
                number_of_coils: null,
                total_coil_length: null,
                picture: null,
                visible: true,
                image_url: null,
            },
            uploadNewProductImage: false,
        };
    },
    methods: {
        openModal() {
            this.isModalOpen = true;
        },
        closeModal() {
            this.isModalOpen = false;
            this.reset();
            this.editMode = false;
            this.uploadNewProductImage = false;
        },
        reset() {
            this.form = {
                id: null,
                brand: null,
                partner_id: null,
                model: null,
                price: null,
                phases: null,
                warranty: null,
                warranty_extension: null,
                kw: null,
                max_kwp: null,
                image_url: null,
                selling_points: null,
                compatible_battery_brands: null,
                sales_points: null,
            };
        },
        async onSubmit() {
            const { valid } = await this.$refs.form.validate();

            if (valid) {
                this.editMode ? this.update(this.form) : this.save(this.form);
            }
        },
        save(data) {
            data.picture = this.$refs.picture.files[0] || null;

            this.$inertia.post(this.route('water-container-create'), data);

            this.reset();
            this.closeModal();

            this.editMode = false;
        },
        edit(data) {
            this.form = Object.assign({}, data);
            this.editMode = true;
            this.openModal();
        },
        update(data) {
            data.picture = this.$refs.picture.files[0] || null;

            this.$inertia.post(this.route('water-container-update', {id: data.id}), data);

            this.reset();
            this.closeModal();
        },
        deleteRow(data) {
            if (
                !confirm(
                    this.$t("water-container.Are you sure you want to delete this water container")
                )
            )
                return;
            data._method = "DELETE";
            this.$inertia.post(this.route('water-container-delete', {id: data.id}), data);
            this.reset();
            this.closeModal();
        },
        updateVisibility(data) {
            this.$inertia.post(this.route('water-container-update-visible', {
                id: data.id,
                flag: !data.visible,
            }))
        },
    },
};
</script>

<style scoped>
table {
    width: 100%;
    table-layout: fixed;
    font-size: 12px;
}

@media screen and (max-width: 1024px) {
    table {
        width: auto;
    }
}

th {
    padding: 10px 0px;
    /* white-space: nowrap; */
    text-overflow: ellipsis;
    /* overflow: hidden; */
    text-align: left;
    box-sizing: border-box;
    padding-left: 10px;
    border-bottom: 1px solid #aaa;
}

td {
    text-align: left;
    box-sizing: border-box;
    padding: 5px 0px;
    padding-left: 10px;
    border-bottom: 1px solid #ccc;
}
</style>
